import React from "react";
import Footer from "./Footer";
import Nav from "./Nav";

const SiteLayout = ({ children }) => {
  return (
    <div className="site-shell">
      <Nav />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default SiteLayout;
